import React, { useEffect, useRef, useState } from 'react';

export default function DeferredSection({ children, fallback = null, rootMargin = '300px 0px', minHeight }) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (visible) return undefined;
    if (!('IntersectionObserver' in window)) {
      setVisible(true);
      return undefined;
    }
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setVisible(true);
        observer.disconnect();
      }
    }, { rootMargin });
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [rootMargin, visible]);

  return <div ref={ref} style={visible ? undefined : { minHeight }}>{visible ? children : fallback}</div>;
}
